import React, { useState, createContext, useContext } from 'react';
import { CheckCircle, X } from 'lucide-react';
interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info';
}
interface ToastContextType {
  showToast: (message: string, type?: 'success' | 'error' | 'info') => void;
}
const ToastContext = createContext<ToastContextType | undefined>(undefined);
export function ToastProvider({
  children
}: {
  children: ReactNode;
}) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const showToast = (message: string, type: 'success' | 'error' | 'info' = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, {
      id,
      message,
      type
    }]);
    // Auto remove after 3 seconds
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, 3000);
  };
  const removeToast = (id: number) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };
  return <ToastContext.Provider value={{
    showToast
  }} data-id="element-211">
      {children}

      {/* Toast Container */}
      <div className="fixed top-24 right-8 z-50 space-y-3" data-id="element-212">
        {toasts.map(toast => <div key={toast.id} className="flex items-center gap-3 bg-white rounded-xl shadow-2xl border border-gray-200 p-4 min-w-[320px] animate-slide-in" style={{
        animation: 'slideIn 0.3s ease-out'
      }} data-id="element-213">
            {toast.type === 'success' && <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-214">
                <CheckCircle className="h-6 w-6 text-green-600" data-id="element-215" />
              </div>}

            <div className="flex-1" data-id="element-216">
              <p className="text-sm font-semibold text-gray-900" data-id="element-217">
                {toast.message}
              </p>
            </div>

            <button onClick={() => removeToast(toast.id)} className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-218">
              <X className="h-5 w-5" data-id="element-219" />
            </button>
          </div>)}
      </div>

      <style data-id="element-220">{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </ToastContext.Provider>;
}
export function useToast() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}